import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { StateAuth } from '../../types';
import AttachmentModal from './AttachmentModal';
import Item from './Item';

import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { serverRequestDelete } from '../../actions/fetchM';

import { TRANSLATION_FILES } from '../../constants/translation';
import {
  GROUP_ID_DEVELOPER_HEADQUARTERS,
  GROUP_ID_DEVELOPER_BRANCH_LEADER,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  GROUP_ID_DEVELOPER_AGENT_LEADER,
} from '../../constants/groups';

class List extends Component {
  static propTypes = {
    auth: StateAuth,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    hideCancel: PropTypes.bool,
    onCancelTransaction: PropTypes.func,
    onUpdated: PropTypes.func,
    projectBankAccount: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static contextTypes = {
    router: PropTypes.object,
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const data = Object.assign({}, props.data);
    data.bookingFeePayments = data.bookingFeePayments.filter(e => e.status !== 'deduction');
    const projectCurrencies = data.project.projectCurrency;
    return {
      data,
      projectCurrencies,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);

    this.state = {
      attachmentModalState: false,
      attachmentModalData: {},
      genericErrMsg: props.t('An error occurred, please refresh page'),
      loading: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  } 
  canDeletePaymentAttachment() {
    const { auth } = this.props;
    if (!auth || !auth.groups || !Array.isArray(auth.groups)) return false;

    const allowedGroupIDs = [
      GROUP_ID_DEVELOPER_HEADQUARTERS,
      GROUP_ID_DEVELOPER_BRANCH_LEADER,
      GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
      GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
      GROUP_ID_DEVELOPER_AGENT_LEADER,
    ];
    
    return auth.groups.some(group => allowedGroupIDs.includes(group.id));
  }  handleCloseAttachment = () => {
    this.setState({
      attachmentModalState: false,
    });
  }
  handleOpenAttachment = (data) => {
    this.setState({
      attachmentModalState: true,
      attachmentModalData: data,
    });
  }
  handleDeleteAttachment = async (id, successCallback) => {
    const { genericErrMsg } = this.state;
    const { store, router } = this.context;
    const { t } = this.props;
    try {
      await this.setLoading(true);
      const response = await serverRequestDelete(
        `/bookings/${router.params.id}/pictures/${id}/`,
        store,
        this.props.token,
      );
      if (response.error) {
        this.handleError(store, response.message);
        return;
      }
      if (this.props.onUpdated) await this.props.onUpdated();
      await this.setLoading(false);
      successCallback(id);
      store.dispatch(flashSuccessMessage({
        header: t('Delete Success'),
        message: t('Picture successfully deleted'),
      }));
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  render() {
    const {
      data,
      attachmentModalState,
      attachmentModalData,
    } = this.state;
    return (
      <div>
        <AttachmentModal
          modalState={attachmentModalState}
          data={attachmentModalData}
          onClose={this.handleCloseAttachment}
          onDelete={this.canDeletePaymentAttachment() ? this.handleDeleteAttachment : null}
        />
        {
          data.bookingFeePayments.map((value, index) => (
            <Grid centered key={index}>
              <Item
                auth={this.props.auth}
                bookingData={this.props.data}
                data={value}
                hideCancel={this.props.hideCancel}
                projectBankAccount={data.project.projectBankAccount}
                projectCurrencies={data.project.projectCurrency}
                openAttachment={this.handleOpenAttachment}
                onCancelTransaction={this.props.onCancelTransaction}
                onUpdated={this.props.onUpdated}
                token={this.props.token}
              />
            </Grid>
          ))
        }
      </div>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.translation)(List);



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/List.jsx